<template>
    <div>
        <el-dialog v-dialogDrag title="更新费用模板信息" :close-on-click-modal="false" fullscreen :before-close="beforeclose"
            :show-close="true" :visible.sync="dialogCartonVisible">
            <!-- 头信息 -->
            <div>
                <el-form :model="templateHead" status-icon ref="templateHead"  :rules="rules"
                    style="display: flex; justify-content: space-around;" label-width="100px" >
                    <el-form-item  label="结算对象" prop="custName" style="width: 100%;">
                        <el-select :disabled="rolePermission === '领导'? false:true" style="width: 100%" v-model="templateHead.custName" placeholder="请选择">
                            <el-option v-for="item in customOption" :key="item.id" :label="item.name"
                                :value="item.name">
                            </el-option>
                        </el-select>
                        <!-- <el-input v-model.trim="templateHead.custName" autocomplete="off"></el-input> -->
                    </el-form-item>
                    <el-form-item  label="模板名称" prop="templateName" style="width: 100%;">
                        <el-input :disabled="rolePermission === '领导'? false:true" v-model="templateHead.templateName" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="模板备注" prop="tempNote" style="width: 100%;">
                        <el-input :disabled="rolePermission === '领导'? false:true" v-model="templateHead.tempNote"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div style="margin-top: 8px;">
                <el-button v-if="rolePermission === '领导'" @click="addRow">添加行</el-button>
                <el-button v-if="rolePermission === '领导'" @click="saveAll" type="primary" style="margin-left: 10px">保存全部</el-button>
                <el-table :data="tableData" :empty-text="'没有数据'" size="mini" style="width: 100%">
                    <el-table-column prop="feeName" label="费用名称" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-select filterable clearable v-model="scope.row.feeName" style="width: 100%"
                                placeholder="请选择费用名称" v-show="scope.row.editing">
                                <el-option v-for="item in feeOption" :key="item.id" :label="item.feeName"
                                    :value="item.feeName">
                                </el-option>
                            </el-select>
                            <span v-show="!scope.row.editing">{{ scope.row.feeName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="currency" label="币制" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-select filterable clearable style="width: 100%" v-model="scope.row.currency"
                                placeholder="请选择币制" v-show="scope.row.editing">
                                <el-option v-for="item in typeOption" :key="item.id" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-show="!scope.row.editing">{{ scope.row.currency }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="containerType" label="箱型" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-select filterable clearable style="width: 100%" v-model="scope.row.containerType"
                                placeholder="请选择箱型" v-show="scope.row.editing">
                                <el-option v-for="item in classOption" :key="item.id" :label="item.value"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <span v-show="!scope.row.editing">{{ scope.row.containerType }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="amount" label="金额" width="auto" align="center">
                        <template slot-scope="scope">
                            <el-input onkeyup="value=value.match(/\d+\.?\d{0,2}/,'')" clearable style="width: 100%"
                                v-model="scope.row.amount" placeholder="请输入金额" v-if="scope.row.editing"></el-input>
                            <span v-show="!scope.row.editing" v-format="'#,##0'">{{ scope.row.amount }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="note" label="备注" align="center" width="auto">
                        <template slot-scope="scope">
                            <el-input clearable v-model="scope.row.note" placeholder="请输入备注"
                                v-if="scope.row.editing"></el-input>
                            <span v-show="!scope.row.editing">{{ scope.row.note }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="rolePermission === '领导'" label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button v-if="!scope.row.editing" @click="startEditing(scope.row)" type="text"
                                size="small">
                                编辑
                            </el-button>
                            <el-button v-else @click="save(scope.row)" type="text" size="small">
                                保存
                            </el-button>
                            <el-button v-if="!scope.row.editing" @click="deleteRow(scope.row)" type="text" size="small"
                                style="margin-left: 10px">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>


            <div slot="footer" class="dialog-footer">
                <el-button @click="beforeclose">取 消</el-button>
                <el-button v-if="rolePermission === '领导'" type="primary" @click="allSaveList('templateHead')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import req from '@/utils/index.js'
import url from '@/config/url1.js'
import url1 from '@/config/url2.js'
export default {
    name: 'changeFeeScheme',
    props: {
        rowData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            rolePermission:localStorage.getItem('role'),
            templateHead: {
                id: '',
                templateName: '',
                tempNote: '',
                custName: ''
            },//费用模板头
            templateDetail: [],//费用明细
            dialogCartonVisible: false,
            customOption: [],//委托单位
            tableData: [],
            typeOption: [],//币制数据
            feeOption: [],//费用名称数据
            classOption: [],//货物分类数据
            rules: {
                custName: [
                    { required: true, message: '请输入结算对象', trigger: 'blur' },
                ],
                templateName: [
                    { required: true, message: '请输入模板名称', trigger: 'blur' },
                ],
            }

            // busId: '',//单据编号id

        }
    },
    created() {
        // this.amendRow();
        this.getcustomList();
        this.getTypeOption();
        this.getFeeList();
        this.getClassOption();



    },
    // computed() {

    //     return this.rowData ? JSON.stringify(this.rowData) : 'No data';
    // },
    mounted() {
        // this.amendDetail();
    },
    methods: {
        // 获取箱型
        getClassOption() {
            let value = '箱型';
            let URL = `${url.getDicList}/?value=${value}`;
            req.post(URL).then(res => {
                if (res.data.code === 200) {
                    this.classOption = res.data.data.data;
                }
            })
        },
        // 关闭之前的回调
        beforeclose() {
            this.$refs.templateHead.resetFields();
            this.templateHead = {};
            this.tableData = [];
            this.$parent.getData();
            this.dialogCartonVisible = false;            
        },
        //父传子 传行信息
        amendDetail() {

            if (this.rowData) {
                this.templateHead = this.rowData;
                let URL = `${url1.getDetailById}/${this.rowData.id}`
                req.get(URL).then(res => {
                    if (res.data.code === 200) {
                        this.tableData = res.data.data;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        })
                    }
                })

            }

        },
        addRow() {
            const newRow = {
                feeName: '',
                currency: '',
                editing: true,
                containerType: '',
                note: '',
            };
            this.tableData.push(newRow);
        },
        deleteRow(row) {
            // 删除行的逻辑
            const index = this.tableData.indexOf(row);
            if (index !== -1) {
                this.tableData.splice(index, 1);
                // if (row.id) {
                //     let URL = `${url.deleteContainer}/${row.id}`;
                //     req.delete(URL).then(res => {
                //         if (res.data.code === 200) {
                //             this.$message({
                //                 type: 'success',
                //                 message: '删除成功'
                //             })
                //             this.amendRow();
                //         } else {
                //             this.$message({
                //                 type: 'error',
                //                 message: res.data.message
                //             })
                //         }
                //     })
                // }

            }
        },
        startEditing(row) {
            this.$set(row, 'editing', true);
        },
        // 确定保存
        allSaveList(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let hasEmptyValue = false;
                    this.tableData.forEach(row => {
                        if (!row.feeName || !row.currency || !row.amount || !row.containerType) {
                            hasEmptyValue = true;
                            return false; // 提前退出循环
                        }
                    });
                    if (hasEmptyValue) {
                        this.$message.warning('请填写完整空白内容');
                    } else {
                        let flag = false;
                        this.tableData.forEach(row => {
                            if (row.editing == true) {
                                flag = true;
                            }

                        })
                        if (flag) {
                            this.$message({
                                type: 'warning',
                                message: '请先保存全部！'
                            })
                        } else {
                            let URL = `${url1.updateTemplate}`;
                            let newArr = this.tableData.map(item => {
                                const { id, ...rest } = item;
                                return rest;
                            })
                            let obj = {
                                templateHead: this.templateHead,
                                templateDetail: newArr
                            }
                            req.post(URL, obj).then(res => {
                                if (res.data.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '更改成功'
                                    })
                                    this.$emit('getData');
                                    // this.amendRow();
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.data.message
                                    })
                                }
                            })
                        }
                    }
                } else {
                    return false;
                }
                });
        },
        save(row) {
            this.$set(row, 'editing', false);
        },
        saveAll() {
            this.tableData.forEach(row => {
                // row.editing = false;
                this.$set(row, 'editing', false);
            });
        },
        //获取委托单位数据
        getcustomList() {
            let URL = `${url1.getList}/?name=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.customOption = res.data.data;
                }
            })
        },
        //获得币制数据
        getTypeOption() {
            let value = '币制';
            let URL = `${url.getDicList}/?value=${value}`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.typeOption = res.data.data.data;
                }
            })
        },
        //获得费用名称
        getFeeList() {
            let URL = `${url.fee}?feeName=`;
            req.get(URL).then(res => {
                if (res.data.code === 200) {
                    this.feeOption = res.data.data;
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped></style>